export const TOGGLE_SIDEBAR = 'TOGGLE_SIDEBAR';
export const TOGGLE_ERROR_PAGE = 'TOGGLE_ERROR_PAGE';

export const GET_NOTIFICATION = 'GET_NOTIFICATION';
export const GET_NOTIFICATION_SUCCESS = `${GET_NOTIFICATION}/SUCCESS`;
export const GET_NOTIFICATION_FAILURE = `${GET_NOTIFICATION}/FAILURE`;

export default {
  TOGGLE_SIDEBAR,
  TOGGLE_ERROR_PAGE,

  GET_NOTIFICATION,
  GET_NOTIFICATION_SUCCESS,
  GET_NOTIFICATION_FAILURE
};
